import { parseDateKey } from "@healthos/shared";
const DAY_LABEL_FORMAT = new Intl.DateTimeFormat("en-US", {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
    year: "numeric",
});
/** Groups by localDate (else UTC day), newest first, preserving order within a day. */
export function groupLogbookEntriesByDay(entries) {
    const groupsByKey = new Map();
    for (const entry of entries) {
        const dateKey = entry.localDate ?? entry.occurredAt.slice(0, 10);
        const existing = groupsByKey.get(dateKey);
        if (existing) {
            existing.entries.push(entry);
            continue;
        }
        groupsByKey.set(dateKey, {
            dateKey,
            dateLabel: DAY_LABEL_FORMAT.format(parseDateKey(dateKey)),
            entries: [entry],
        });
    }
    return [...groupsByKey.values()].sort((a, b) => (a.dateKey < b.dateKey ? 1 : -1));
}
//# sourceMappingURL=logbook-history-grouping.js.map